<template>
  <div class="dashboard__view">
    <div class="page">
      <div class="relative">
        <div class="text-light">
          <p>
            Filter Transactions by :
            <span @click="openFilters = !openFilters"
              >All Transactions
              <svg
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="openFilters ? '' : 'rotate'"
              >
                <path
                  d="M1 1L5 5L9 1"
                  stroke="#e00b5b"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </p>
        </div>
        <div class="filter-dropdown" v-if="openFilters">
          <div class="filter-title">Unique Reference</div>
          <div class="form__item">
            <input
              class="form__input"
              type="text"
              v-model="filterList.reference"
            />
          </div>
          <div class="filter-title">NIP Session ID</div>
          <div class="form__item">
            <input
              class="form__input"
              type="text"
              v-model="filterList.nip_session_id"
            />
          </div>
          <div class="filter-title">Customer Reference</div>
          <div class="form__item">
            <input
              class="form__input"
              type="text"
              v-model="filterList.customer_reference"
            />
          </div>
          <div class="form__item">
            <input
              class="form__input vNuban__input"
              type="number"
              @keypress="isNumber($event)"
              v-model="filterList.vnuban"
              placeholder="vNuban"
            />
          </div>
          <div class="">
            <p class="filter-title">STATUS</p>
            <div
              v-for="status in statusGroup"
              class="status-element"
              :key="status.id"
              @click="() => (filterList.status = status.id)"
            >
              <p v-if="status.id === filterList.status">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="8" fill="#e00b5b" />
                  <path
                    d="M11 6L6.875 10L5 8.18182"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
              <p v-else>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="7.5" stroke="#979797" />
                </svg>
              </p>
              <p class="filter-title">{{ status.name }}</p>
            </div>
          </div>
          <div>
            <div>
              <div class="mt-4">
                <p class="filter-title">Start Date</p>
                <input
                  placeholder="dd/mm/yyyy"
                  class="date margin-right"
                  type="date"
                  id="_date"
                  v-model="filterList.from"
                />
              </div>
              <div class="end-date mt-4">
                <p class="filter-title">End Date</p>
                <input
                  placeholder="dd/mm/yyyy"
                  class="date"
                  type="date"
                  id="date"
                  v-model="filterList.to"
                />
              </div>
            </div>
          </div>
          <div class="button-group">
            <button
              class="btn woven-border-only woven-red"
              @click="clearFilter"
            >
              Reset Filter
            </button>
            <button class="btn woven-color" @click="triggerFilter">
              <p>Filter</p>
            </button>
          </div>
        </div>
      </div>
      <br />
    </div>

    <div class="list">
      <div class="tab__content">
        <div class="tab__content__top">
          <div class="tab__content__top__left">
            {{ pageInfo.total }} Transactions
            <div class="actions">
              <div
                class="confirm_btn"
                v-if="selectedTransactions.length > 0"
                @click="toggleUpdateModal"
              >
                Update selected ({{ selectedTransactions.length }})
              </div>
              <div
                class="reverse_btn"
                v-if="selectedTransactions.length > 0"
                @click="toggleReverseModal"
              >
                Reverse selected
              </div>
            </div>
          </div>
        </div>
        <EmptyState v-if="emptyState" type="not-found" icon="transaction" />

        <div v-else>
          <!-- Loader -->
          <div class="loader" v-if="loading">
            <span aria-hidden="true" class="spinner-border"></span>
          </div>
          <table class="table card-table" v-else>
            <thead>
              <tr>
                <th>Merchant ID</th>
                <th>Account</th>
                <th>Payment Type</th>
                <th>Service</th>
                <th>AMOUNT</th>
                <th>STATUS</th>
                <th>TRANSACTION DATE</th>
                <th style="width: 10px; padding-left: 10px; padding-right: 10px;"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                :key="item.unique_reference"
                @click="goTo(item)"
                v-for="item in transactionList"
              >
                <td>{{ item.merchant_id }}</td>
                <td>{{ item.account }}</td>
                <td>{{ item.payment_type }}</td>
                <td>{{ item.service }}</td>
                <td>₦{{ item.amount | money }}</td>
                <td :class="isActiveTransactionStatus(item.status) ? 'green-status' : item.status.toLowerCase() === 'failed' ? 'red-status' : 'other-status'">{{ displayTransactionStatus(item.status) }}</td>
                <td>{{ moment(item.createdAt || date).format("llll") }}</td>
                <td>
                  <span
                    class="retry-icon"
                    :class="[
                      item.status.toLowerCase() === 'failed' ? '' : 'hide',
                      isTransactionRetrying(item) ? 'retry-icon--disabled' : '',
                    ]"
                    role="button"
                    :tabindex="isTransactionRetrying(item) ? -1 : 0"
                    :aria-disabled="isTransactionRetrying(item) ? 'true' : 'false'"
                    :aria-label="
                      isTransactionRetrying(item) ? 'Retry in progress' : 'Retry'
                    "
                    @click.stop="openRetryProviderModal(item)"
                    @keydown.enter.prevent="openRetryProviderModal(item)"
                    @keydown.space.prevent="openRetryProviderModal(item)"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                        stroke="#e00b5b"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            class="table__details"
            v-if="loading !== true && emptyState !== true"
          >
            <div class="table__details__left">
              <span class="text-muted" v-if="pageInfo.total"
                >Page {{ pageInfo.current_page }} of
                {{ pageInfo.total_pages }}</span
              >
            </div>
            <div class="table__details__right">
              <Pagination :numberOfPages="pageInfo.total_pages" />
            </div>
            <div class="table__details__right"></div>
          </div>
        </div>
      </div>
      <ConfirmBulkTransactionsUpdate
        v-show="showUpdateTransaction && selectedTransactions.length > 0"
        @hide="toggleUpdateModal"
        @completed="completed"
        @completedWithErrors="completedWithErrors"
        :transactions="selectedTransactions"
      />
      <ConfirmBulkTransactionsReversal
        v-show="showReverseTransaction && selectedTransactions.length > 0"
        @hide="toggleReverseModal"
        @completed="completed"
        @completedWithErrors="completedWithErrors"
        :transactions="selectedTransactions"
      />
    </div>

    <!--  query missing transaction modal-->
    <extend-modal
      classes="justify-content-center"
      :toggle="toggleTransactionQueryModal"
      v-if="showTransactionQueryModal"
    >
      <div class="modal-body">
        <svg
          width="60"
          height="61"
          viewBox="0 0 60 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M57.5 27.501C56.12 27.501 55 28.621 55 30.001C55 43.786 43.785 55.001 30 55.001C16.215 55.001 5 43.786 5 30.001C5 16.216 16.215 5.00102 30 5.00102C34.57 5.00102 39.135 6.28102 43.0725 8.50352L39.8425 11.7335C39.1275 12.4485 38.9125 13.5235 39.3 14.4585C39.6875 15.391 40.6 16.001 41.6125 16.001H52.6125C53.9925 16.001 55.1125 14.881 55.1125 13.501V2.50102C55.1125 1.49102 54.5025 0.578524 53.57 0.191024C52.6325 -0.196477 51.56 0.0160235 50.845 0.733524L46.735 4.84352C41.815 1.75352 35.9825 0.00102351 30 0.00102351C13.4575 0.00102351 0 13.4585 0 30.001C0 46.5435 13.4575 60.001 30 60.001C46.5425 60.001 60 46.5435 60 30.001C60 28.621 58.88 27.501 57.5 27.501Z"
            fill="#e00b5b"
          />
          <path
            d="M46.25 30.001C46.25 38.976 38.975 46.251 30 46.251C21.025 46.251 13.75 38.976 13.75 30.001C13.75 21.026 21.025 13.751 30 13.751C38.975 13.751 46.25 21.026 46.25 30.001Z"
            fill="#e00b5b"
          />
          <path
            d="M36.8751 32.741C36.8751 31.396 36.2576 30.2085 35.3151 29.431C35.6851 28.791 35.9126 28.046 35.9126 27.241C35.9126 25.3385 34.6926 23.7435 33.0276 23.2085V21.501C33.0276 20.671 32.3826 20.001 31.5851 20.001C30.7876 20.001 30.1426 20.6735 30.1426 21.501V23.001H29.1801V21.501C29.1801 20.671 28.5351 20.001 27.7376 20.001C26.9401 20.001 26.2951 20.6735 26.2951 21.501V23.001H25.8151C25.0176 23.001 24.3726 23.6735 24.3726 24.501V30.001V35.501C24.3726 36.3285 25.0176 37.001 25.8151 37.001H26.2951V38.501C26.2951 39.331 26.9426 40.001 27.7376 40.001C28.5326 40.001 29.1801 39.3285 29.1801 38.501V37.001H30.1426V38.501C30.1426 39.331 30.7876 40.001 31.5851 40.001C32.3801 40.001 33.0276 39.3285 33.0276 38.501V36.976C35.1676 36.8485 36.8751 35.016 36.8751 32.741ZM27.2601 26.001H31.8376C32.4951 26.001 33.0301 26.5585 33.0301 27.261C33.0301 27.9435 32.4951 28.501 31.8376 28.501H27.2601V26.001ZM32.7976 34.001H27.2601V31.501H31.8376H32.8001C33.4576 31.501 33.9926 32.0585 33.9926 32.761C33.9901 33.4435 33.4551 34.001 32.7976 34.001Z"
            fill="#B6E4E9"
          />
          <path
            d="M30.0024 0.00366211H29.5274C13.3599 0.253662 0.252441 13.3587 0.00244141 29.5287V30.4737C0.257441 46.7987 13.6149 60.0012 29.9999 60.0012H30.0024V55.0012H29.9999C16.2149 55.0012 4.99994 43.7862 4.99994 30.0012C4.99994 16.2162 16.2149 5.00116 29.9999 5.00116H30.0024V0.00366211Z"
            fill="#FFDADB"
          />
          <path
            d="M30.0025 31.501H27.2575V34.001H30.0025V31.501ZM30.0025 26.001H27.2575V28.501H30.0025V26.001ZM30 13.751C21.025 13.751 13.75 21.026 13.75 30.001C13.75 38.976 21.025 46.251 30 46.251H30.0025V37.001H29.18V38.501C29.18 39.331 28.535 40.001 27.7375 40.001C26.94 40.001 26.295 39.3285 26.295 38.501V37.001H25.815C25.0175 37.001 24.3725 36.3285 24.3725 35.501V30.001V24.501C24.3725 23.6735 25.0175 23.001 25.815 23.001H26.295V21.501C26.295 20.671 26.9425 20.001 27.7375 20.001C28.5325 20.001 29.18 20.6735 29.18 21.501V23.001H30.0025V13.751H30Z"
            fill="#FFDADB"
          />
          <path
            d="M27.74 20.001C26.945 20.001 26.2975 20.6735 26.2975 21.501V23.001H25.8175C25.02 23.001 24.375 23.6735 24.375 24.501V30.001V35.501C24.375 36.3285 25.02 37.001 25.8175 37.001H26.2975V38.501C26.2975 39.331 26.945 40.001 27.74 40.001C28.535 40.001 29.1825 39.3285 29.1825 38.501V37.001H30.005V34.001H27.26V31.501H30.005V28.501H27.26V26.001H30.005V23.001H29.1825V21.501C29.1825 20.6735 28.5375 20.001 27.74 20.001Z"
            fill="#B4D2D7"
          />
        </svg>

        <div class="boxed">
          <form class="text-left" @submit.prevent="queryMissingTransaction()">
            <!--request form-->
            <div class="text-center">
              <h2>Query Transaction</h2>
              <p>Fill in the transaction details.</p>
            </div>

            <div class="form__flex">
              <div class="space-down">
                <Dropdown
                  title="Collection Bank"
                  :useModalDataToggle="false"
                  label="Select bank"
                  :options="bankList.length > 0 ? bankList : []"
                  :onOptionSelected="
                    ({ id }) =>
                      ($v.modalQueryMissingTransactionForm.bank.$model = id)
                  "
                />
                <span
                  class="attention"
                  v-if="$v.modalQueryMissingTransactionForm.bank.$error"
                  >Please specify the bank</span
                >
              </div>
            </div>

            <div class="form__flex">
              <div class="form__flex__item">
                <label class="form__label text-danger" for>vNuban</label>
                <input
                  label="Add a note"
                  class="form__input"
                  v-model="modalQueryMissingTransactionForm.vNuban"
                />
              </div>
            </div>

            <div class="form__flex">
              <div class="form__flex__item">
                <label class="form__label text-danger" for>Session ID</label>
                <input
                  class="form__input"
                  type="text"
                  v-model.trim="
                    $v.modalQueryMissingTransactionForm.sessionId.$model
                  "
                />
                <span
                  class="attention"
                  v-if="$v.modalQueryMissingTransactionForm.sessionId.$error"
                  >Please provide either a session ID or VNUBAN</span
                >
              </div>
            </div>

            <div class="form__flex">
              <div class="form__flex__item border-0">
                <div class="d-flex">
                  <input
                    placeholder="Start Date"
                    class="date"
                    type="text"
                    onfocus="(this.type='date')"
                    id="missing-transaction-date"
                    v-model="$v.modalQueryMissingTransactionForm.date.$model"
                  />
                  <svg
                    data-v-cd437612=""
                    width="30"
                    height="40"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="pointer ml-3 mb-0"
                    title="Remove Selection"
                    v-if="modalQueryMissingTransactionForm.date"
                    @click="clearDateInput"
                  >
                    <path
                      data-v-cd437612=""
                      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
                      stroke="#C61010"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      data-v-cd437612=""
                      d="M4 5L15 16"
                      stroke="#C61010"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </div>
                <span
                  class="attention"
                  v-if="$v.modalQueryMissingTransactionForm.date.$error"
                  >Transaction date is needed when querying by VNUBAN</span
                >
              </div>
            </div>
            <div>
              <button
                class="btn btn--primary"
                type="submit"
                :disabled="queryingMissingTransaction"
              >
                {{ queryingMissingTransaction ? "Processing..." : "Submit" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </extend-modal>

    <div
      v-if="showRetryProviderModal"
      class="retry-provider-shell"
      @click.self="closeRetryProviderOverlay"
    >
      <div
        class="retry-provider-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="retry-provider-title"
        @click.stop
      >
        <button
          type="button"
          class="retry-provider-close"
          aria-label="Close"
          :disabled="retrySubmitting"
          @click="closeRetryProviderOverlay"
        >
          <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M8.32867 7.43827L14.8284 0.992053C15.0572 0.7651 15.0572 0.397139 14.8284 0.170215C14.5995 -0.0567093 14.2285 -0.0567384 13.9997 0.170215L7.49998 6.61644L1.00029 0.170215C0.77145 -0.0567384 0.400436 -0.0567384 0.171628 0.170215C-0.05718 0.397168 -0.0572093 0.765129 0.171628 0.992053L6.67133 7.43824L0.171628 13.8845C-0.0572093 14.1114 -0.0572093 14.4794 0.171628 14.7063C0.286032 14.8198 0.436002 14.8765 0.585972 14.8765C0.735943 14.8765 0.885884 14.8198 1.00032 14.7063L7.49998 8.26011L13.9997 14.7063C14.1141 14.8198 14.2641 14.8765 14.414 14.8765C14.564 14.8765 14.7139 14.8198 14.8284 14.7063C15.0572 14.4793 15.0572 14.1114 14.8284 13.8845L8.32867 7.43827Z"
              fill="#e00b5b"
              stroke="#e00b5b"
              stroke-width="2"
            />
          </svg>
        </button>
        <div class="retry-provider-dialog__body">
          <div class="text-center retry-provider-dialog__header">
            <h2 id="retry-provider-title">Choose a provider</h2>
            <p>
              Select the {{ retryOverlayTypePhrase }} provider to use for this
              retry.
            </p>
          </div>
          <div
            v-if="retryProviderChoices.length"
            class="retry-provider-dialog__main"
          >
            <div class="retry-provider-dd" ref="retryProviderDdRoot">
              <p class="retry-provider-field-label">Provider</p>
              <button
                type="button"
                class="retry-provider-dd__trigger"
                aria-haspopup="listbox"
                :aria-expanded="retryCustomDdOpen ? 'true' : 'false'"
                @click.stop="toggleRetryCustomDd"
              >
                <span class="retry-provider-dd__trigger-text">{{
                  retrySelectedProviderLabel
                }}</span>
                <svg
                  class="retry-provider-dd__chevron"
                  :class="{
                    'retry-provider-dd__chevron--open': retryCustomDdOpen,
                  }"
                  width="10"
                  height="7"
                  viewBox="0 0 10 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    opacity="0.6"
                    d="M8.29289 0.302766C8.68342 -0.100922 9.31658 -0.100922 9.70711 0.302766C10.0976 0.706454 10.0976 1.36096 9.70711 1.76465L5.70711 5.89948C5.31658 6.30317 4.68342 6.30317 4.29289 5.89948L0.292893 1.76465C-0.0976311 1.36096 -0.0976311 0.706454 0.292893 0.302766C0.683418 -0.100922 1.31658 -0.100922 1.70711 0.302766L5 3.70666L8.29289 0.302766Z"
                    fill="#261940"
                  />
                </svg>
              </button>
              <div
                v-show="retryCustomDdOpen"
                class="retry-provider-dd__panel"
                role="listbox"
              >
                <button
                  v-for="opt in retryProviderDropdownOptions"
                  :key="opt.id"
                  type="button"
                  class="retry-provider-dd__option"
                  role="option"
                  :aria-selected="
                    isSameRetryProvider(opt.provider) ? 'true' : 'false'
                  "
                  :class="{
                    'retry-provider-dd__option--active': isSameRetryProvider(
                      opt.provider
                    ),
                  }"
                  @click.stop="selectRetryProviderOption(opt)"
                >
                  {{ opt.value }}
                </button>
              </div>
            </div>
            <button
              class="btn woven-color retry-provider-submit"
              type="button"
              :disabled="!retrySelectedProvider || retrySubmitting"
              @click="confirmRetrySubmit"
            >
              {{ retrySubmitting ? "Submitting..." : "Retry" }}
            </button>
          </div>
          <p v-else class="retry-provider-empty">No providers available.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import emptyTransactions from "../../../components/emptytransactions";
import Inputv2Search from "../../../components/inputv2-search";
import Pagination from "@/components/pagination.vue";
import InputV2 from "../../../components/inputv2";
import ButtonV2 from "../../../components/buttonV2";
import Modal from "../../../components/modal";
import WovenStrip from "../../../components/wovenstrip";
import Textarea from "../../../components/textarea";
import Dropdown from "@/components/dropdown";
import StatusIndicator from "@/components/status-indicator.vue";
import EmptyState from "@/components/empty-state.vue";
import ExtendModal from "../../../components/ExtendModal";
import { required, requiredIf } from "vuelidate/lib/validators";
import ConfirmBulkTransactionsUpdate from "./ConfirmBulkTransactionsUpdate.vue";
import ConfirmBulkTransactionsReversal from "@/components/ConfirmBulkTransactionsReversal.vue";

export default {
  metaInfo: {
    title: "Transactions",
  },
  created() {
    this.fetchTransactions();
    this.fetchProviders();
    this._closeRetryDdOutside = (e) => this.closeRetryDdIfOutside(e);
    document.addEventListener("click", this._closeRetryDdOutside, true);
  },
  beforeDestroy() {
    document.removeEventListener("click", this._closeRetryDdOutside, true);
  },

  components: {
    ExtendModal,
    Datepicker,
    Inputv2Search,
    InputV2,
    ButtonV2,
    Modal,
    WovenStrip,
    Textarea,
    Dropdown,
    Pagination,
    StatusIndicator,
    EmptyState,
    ConfirmBulkTransactionsUpdate,
    ConfirmBulkTransactionsReversal
  },

  validations: {
    modalQueryMissingTransactionForm: {
      sessionId: {
        required: requiredIf(function (modalQueryMissingTransactionForm) {
          return (
            !modalQueryMissingTransactionForm.vNuban.length &&
            !modalQueryMissingTransactionForm.sessionId.length
          );
        }),
      },
      date: {
        required: requiredIf(function (modalQueryMissingTransactionForm) {
          return !!modalQueryMissingTransactionForm.vNuban.length;
        }),
      },
      bank: {
        required,
      },
    },
  },

  data() {
    return {
      specificTransaction: {},
      specificAudit: [],
      showFilterDateInput: false,
      queryingMissingTransaction: false,
      transactionList: "",
      pageInfo: "",
      search_input: "",
      showUpdateTransaction: false,
      showReverseTransaction: false,
      filterList: {
        reference: this.$route.query.unique_reference
          ? this.$route.query.unique_reference
          : "",
        customer_reference: this.$route.query.account_reference
          ? this.$route.query.account_reference
          : "",
        nip_session_id: this.$route.query.nip_session_id
          ? this.$route.query.nip_session_id
          : "",
        vnuban: this.$route.query.nuban ? this.$route.query.nuban : "",
        status: this.$route.query.status ? this.$route.query.status : "",
        to: this.$route.query.to ? this.$route.query.to : "",
        from: this.$route.query.from ? this.$route.query.from : "",
      },
      disabled: false,
      polling: "",
      exportDisabled: false,
      loading: true,
      emptyState: false,
      openFilters: false,
      showModal: false,
      showTransactionQueryModal: false,
      styleClass: "",
      statusGroup: [
        {
          id: "Active",
          name: "Active",
        },
        {
          id: "Failed",
          name: "Failed",
        },
        {
          id: "Pending",
          name: "Pending",
        },
      ],
      modalQueryMissingTransactionForm: {
        sessionId: "",
        date: "",
        vNuban: "",
        bank: "",
      },
      selectedTransactions: [],
      providers: [],
      showRetryProviderModal: false,
      retryTransactionItem: null,
      retrySubmitting: false,
      retryingTransactionId: null,
      retrySelectedProvider: null,
      retryCustomDdOpen: false,
    };
  },

  methods: {
    moment: window.moment,
    isActiveTransactionStatus(status) {
      const s = status.toLowerCase();
      return s === "active" || s === "successful" || s === "successfully_retried";
    },
    displayTransactionStatus(status) {
      return status.toLowerCase() === "successfully_retried" ? "Active" : status;
    },
    fetchAudit(value) {
      this.$http
        .get(`dashboard/audits?entity_id=${value}&entity_type=transaction`)
        .then((response) => {
          this.specificAudit = response.body.data.audits;
        });
    },
    clearSearchData() {
      this.search_input = "";
    },
    toggleUpdateModal() {
      this.showUpdateTransaction = !this.showUpdateTransaction;
    },
    toggleReverseModal() {
      this.showReverseTransaction = !this.showReverseTransaction;
    },
    completed() {
      this.$notify({
        group: "notifications-default",
        type: "success text-white",
        title: "Success",
        text: "Updated successfully",
      });
      this.selectedTransactions = [];
      this.fetchTransactions();
    },
    completedWithErrors(errors) {
      this.$notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: "Some transactions were not updated successfully",
      });
      this.selectedTransactions = this.selectedTransactions.filter(
        (transaction) =>
          errors
            .map((error) => error.unique_reference)
            .includes(transaction.unique_reference)
      );
      this.fetchTransactions();
    },
    handleSearch: function () {
      // Convert object to multiple arrays with name and value
      let generatedQuery = this.returnQuery();
      let appendedQuery = "";
      this.loading = true;
      // check for mode to append query
      if (!this.mode) {
        appendedQuery = "&ignore_admin_flag=1";
      } else {
        appendedQuery = "&ignore_admin_flag=1&is_test=1";
      }

      this.$http
        .get(
          `dashboard/transactions/search?query=${this.search_input}&${generatedQuery}${appendedQuery}`
        )
        .then((response) => {
          if (response.body.data.transactions.length > 0) {
            this.transactionList = response.body.data.transactions;
            this.pageInfo = response.body.data.page_info;
            this.emptyState = false;
            this.loading = false;
          } else {
            this.emptyState = true;
            this.loading = false;
          }
        })
        .catch((error) => {
          // LOG Error
          this.loading = false;
        });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    goTo(item) {
      if (item.unique_reference) {
        this.$router.push({
          name: "transaction-details",
          params: { id: item.unique_reference },
        });
      }
    },
    async toggleModal(item) {
      await this.fetchAudit(item.unique_reference);
      this.specificTransaction = item;
      this.showModal = !this.showModal;
      this.styleClass =
        this.styleClass === "display: block"
          ? "display: none !important"
          : "display: block";
    },
    toggleShowDateFilter() {
      this.showFilterDateInput = !this.showFilterDateInput;
    },
    toggleFilters() {
      this.openFilters = !this.openFilters;
    },
    returnQuery() {
      let queryParams = Object.entries(this.$route.query);
      let generatedQuery = "";
      let i = 0;
      // Loop through arrays and generate the query string
      for (let [name, value] of queryParams) {
        generatedQuery += `${name}=${value}`;
        i++;
        if (i < queryParams.length) {
          generatedQuery += "&";
        }
      }
      return generatedQuery;
    },
    generatePaginationLink(pageNum) {
      return {
        path: "/dashboard/bills-payment",
        query: {
          ...this.$route.query,
          page: pageNum,
        },
      };
    },
    triggerFilter() {
      let queryObject = {};
      if (this.filterList.reference) {
        queryObject.unique_reference = this.filterList.reference.trim();
      }
      if (this.filterList.nip_session_id) {
        queryObject.nip_session_id = this.filterList.nip_session_id.trim();
      }
      if (this.filterList.customer_reference) {
        queryObject.account_reference =
          this.filterList.customer_reference.trim();
      }
      if (this.filterList.vnuban) {
        queryObject.vnuban = this.filterList.vnuban.trim();
      }
      if (this.filterList.status) {
        queryObject.status = this.filterList.status;
      }
      if (this.filterList.to) {
        queryObject.to = moment(this.filterList.to).format("YYYY-MM-DD");
      }
      if (this.filterList.from) {
        queryObject.from = moment(this.filterList.from).format("YYYY-MM-DD");
      }
      if (this.$route.query.merchantId) {
        queryObject.merchantId = this.$route.query.merchantId;
      }
      if (this.$route.query.bankCode) {
        queryObject.bankCode = this.$route.query.bankCode;
      }

      queryObject.page = 1;
      //Route to page with query
      this.$router.push({
        path: "/dashboard/bills-payment",
        query: queryObject,
      });

      //Close filter modal
      this.openFilters = !this.openFilters;
    },
    clearFilter() {
      this.filterList = {
        reference: "",
        vnuban: "",
        status: "",
        to: "",
        from: "",
      };
      this.$router.push({ path: "/dashboard/transactions?page=1" });
    },
    fetchTransactions() {
      // Convert object to multiple arrays with name and value
      const url = process.env.VUE_APP_BILL_URL;
      let generatedQuery = this.returnQuery();
      this.loading = true;

      this.$http
        .get(`${url}/admin/transactions?${generatedQuery}`)
        .then((response) => {
          if (response.body.data.length > 0) {
            this.transactionList = response.body.data;
            this.pageInfo = {
            "total": response.body.pageDetails.totalItems,
            "current_page": response.body.pageDetails.currentPage,
            "total_pages": response.body.pageDetails.totalPages
            };
            this.emptyState = false;
            this.loading = false;
          } else {
            this.emptyState = true;
            this.loading = false;
          }
        })
        .catch((error) => {
          // LOG Error
          this.loading = false;
        });
    },

    //query missing transactions
    toggleTransactionQueryModal() {
      this.showTransactionQueryModal = !this.showTransactionQueryModal;
    },

    clearDateInput() {
      this.modalQueryMissingTransactionForm.date = "";
    },

    queryMissingTransaction() {
      this.$v.modalQueryMissingTransactionForm.$touch();
      // this.showTransactionQueryModal = false;
    },
    async fetchProviders() {
      const url = process.env.VUE_APP_BILL_URL;
      await this.fetchProviderUrl(`${url}/admin/provider`);
    },
    fetchProviderUrl(href, type) {
      return this.$http.get(href).then((response) => {
        const data = response.body;
        if (data && data.length > 0) {
          this.providers = data;
        }
      }).catch(() => {});
    },
    isTransactionRetrying(item) {
      if (!item || this.retryingTransactionId == null) return false;
      return String(this.retryingTransactionId) === String(item.id);
    },
    openRetryProviderModal(item) {
      if (this.isTransactionRetrying(item)) return;
      this.retryTransactionItem = item;
      this.retrySelectedProvider = this.findProviderForTransaction(item);
      this.retryCustomDdOpen = false;
      this.showRetryProviderModal = true;
    },
    findProviderForTransaction(item) {
      if (!item || !this.providers.length) return null;
      const provider_id = item.provider_id;
      if (provider_id == null || provider_id === "") return null;
      return this.providers.find((p) => String(p.id) === String(provider_id)) || null;
    },
    closeRetryProviderOverlay() {
      if (this.retrySubmitting) return;
      this.showRetryProviderModal = false;
      this.retryTransactionItem = null;
      this.retrySelectedProvider = null;
      this.retryCustomDdOpen = false;
    },
    toggleRetryCustomDd() {
      this.retryCustomDdOpen = !this.retryCustomDdOpen;
    },
    selectRetryProviderOption(opt) {
      this.retrySelectedProvider = opt.provider;
      this.retryCustomDdOpen = false;
    },
    closeRetryDdIfOutside(e) {
      if (!this.showRetryProviderModal || !this.retryCustomDdOpen) return;
      const root = this.$refs.retryProviderDdRoot;
      if (root && !root.contains(e.target)) this.retryCustomDdOpen = false;
    },
    isSameRetryProvider(p) {
      const s = this.retrySelectedProvider;
      if (!s || !p) return false;
      return String(s.id) === String(p.id);
    },
    confirmRetrySubmit() {
      const item = this.retryTransactionItem;
      const provider = this.retrySelectedProvider;
      if (!item || !provider) return;
      this.retryCustomDdOpen = false;
      this.showRetryProviderModal = false;
      this.retryTransactionItem = null;
      this.retrySelectedProvider = null;
      this.downloadReceipt(item, provider);
    },
    providerLabel(p) {
      if (!p) return "";
      return p.name || p.provider_name || `Provider ${p.id}`;
    },
    clearRetryInFlight() {
      this.retrySubmitting = false;
      this.retryingTransactionId = null;
    },
    downloadReceipt(item, provider) {
      if (!item || !provider) return;
      this.retryingTransactionId = item.id;
      this.retrySubmitting = true;
      this.postBillRetry(item, provider)
        .then(() => this.onRetryPosted())
        .catch((err) => this.onRetryFailed(err))
        .finally(() => this.clearRetryInFlight());
    },
    postBillRetry(item, provider) {
      const url = process.env.VUE_APP_BILL_URL;
      return this.$http.post(`${url}/admin/retry/transaction/${item.id}`, {
        provider_id: item.provider_id,
      });
    },
    onRetryPosted() {
      this.$notify({
        group: "notifications-default",
        type: "success text-white",
        title: "Success",
        text: "Retry submitted",
      });
      this.fetchTransactions();
    },
    onRetryFailed(err) {
      const msg =
        err.body && err.body.message ? err.body.message : "Retry request failed";
      this.$notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: msg,
      });
    },
  },

  computed: {
    mode() {
      return this.$store.state.userDetails.is_test;
    },
    bankNames() {
      return this.$store.state.bankNames;
    },
    bankList() {
      return this.$store.getters.getBankListKeyAndValuePair;
    },
    userDetails() {
      return this.$store.state.userDetails;
    },
    withBankInfo() {
      const bankCode = this.$route.query.bankCode;
      if (!bankCode) {
        return false;
      }
      return this.bankNames[bankCode];
    },
    retryProviderChoices() {
      return this.providers;
    },
    retryProviderDropdownOptions() {
      return this.retryProviderChoices.map((p, idx) => ({
        id: `${p.type}_${p.id}_${idx}`,
        value: this.providerLabel(p),
        provider: p,
      }));
    },
    retrySelectedProviderLabel() {
      if (!this.retrySelectedProvider) return "Select provider";
      return this.providerLabel(this.retrySelectedProvider);
    },
    retryOverlayTypePhrase() {
      const item = this.retryTransactionItem;
      const raw = (item && (item.payment_type || item.service)) || "";
      const t = raw.trim().replace(/_/g, " ");
      if (!t) return "bill";
      return t.toLowerCase();
    },
  },

  watch: {
    // call again the fetch method if the route changes; this is necessary especially because of users
    // using the search and might be on this route already.
    $route: "fetchTransactions",
    pageInfo: {
      handler() {
        this.selectedTransactions = [];
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.width-100 {
  width: 100% !important;
}
.border-0 {
  border: none;
}

.vNuban__input::-webkit-inner-spin-button,
.vNuban__input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.header {
  padding: 30px 0 30px 25px;
  > p {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.1em;
    color: rgba(101, 93, 121, 0.7);
  }
  > div {
    display: flex;
    margin-top: 49px;
    svg {
      cursor: pointer;
    }
    p {
      margin-left: 16px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 19px;
      color: #261940;
    }
  }
}
.loading {
  margin: 10px 30px;
}
.button-image {
  margin-right: 5px;
}
.settlement-details:nth-child(1) {
  padding: 45px;
}
.settlement-details {
  font-family: "Calibre" !important;
  background: #fff;
  display: flex;
  justify-content: space-between;
  margin: 32px 0;
  padding: 40px 30px;
  overflow: hidden;
  &:hover {
    overflow-x: auto;
  }
  &__title {
    min-width: 200px;
    h1 {
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 23px;
      color: #7a153c;
      margin-bottom: 12px;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 20px;
      color: #616e7c;
      max-width: 189px;
    }
  }

  &__contents {
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    border-radius: 6px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom: none;
    > div {
      display: flex;
      padding-bottom: 35px;
    }
    .btn {
      width: 171px;
      margin-top: 20px;
      .btn--text {
        flex-grow: 1;
      }
    }
    .dropdown {
      width: 171px;
    }
    &__content:not(:last-child) {
      border-right: 0.5px solid rgba(38, 25, 64, 0.15);
      margin-right: 50px;
    }
    &__content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      min-width: 150px;
      h1 {
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 22px;
        color: #261940;
        opacity: 0.8;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 14px;
        color: rgba(38, 25, 64, 0.7);
        margin-bottom: 8px;
      }
      .btn--sm {
        width: 171px;
      }
      .amount {
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 23px;
        color: #38091b;
        opacity: 0.8;
      }
    }
  }
}

.tag.no-bg {
  padding: 0 !important;
}
.sudo-transactions-details {
  max-width: 520px;
  max-height: 80vh;
  width: 100% !important;
  height: 80vh;
  padding: 0;
  .modal {
    height: 80vh;
    padding: 0;
    display: block !important;
  }
  .drop-down {
    width: 100%;
  }

  .left {
    max-width: 55%;
    flex: 1;
    padding: 10px;
    overflow: auto;
  }
  .right {
    max-width: 45%;
    width: 400px;
    flex: 0.5;
    background: #f5f5f7;
    border-radius: 6px;
    text-align: left;
    padding: 10px;
    margin: 40px;

    .audit-title {
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 22px;
      padding: 10px 15px;

      color: #000000;
    }
    .audit-box {
      padding: 15px;
      border-bottom: 1px solid #ebf0f4;
    }
    .audit-type {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: rgba(0, 0, 0, 0.7);
    }
    .audit-date {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 20px;
      color: rgba(38, 25, 64, 0.6);
    }
  }
  &.modal-content,
  &__content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: #ffffff !important;
    border-radius: 10px 10px 0px 0px;
    max-width: 90%;
    width: 100% !important;
    height: 100%;
    margin: auto;
    text-align: center;
    padding: 15px 0;

    &__transaction_item {
      display: flex;
      justify-content: space-between;
      width: 100%;
      border-bottom: 1px solid #ebf0f4;
      padding: 20px 0;

      &__top {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: rgba(0, 0, 0, 0.5);
        padding: 10px 0;
      }
      &__info {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 18px;
        color: #261940;
      }
    }
  }
  &__title {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    text-align: left;
    color: #000000;
  }
}

.page {
  z-index: 1000 !important;
}
.sudo-modal {
  min-width: 50% !important;
  display: block !important;
  padding-bottom: 0 !important;
  &__content {
    display: block !important;
    position: relative;

    .dropdown-options {
      overflow-y: auto;
      height: 100%;
      min-height: 12rem;
    }
  }
}
.space-down {
  margin-bottom: 32px;
  width: 100%;
  position: relative;
}
</style>
<style lang="scss" scoped>
// filter styles start
.relative {
  position: relative;
}
.end-date {
  margin-top: 15px;
}
.rotate {
  transform: rotate(180deg);
}
.woven-color {
  background: #e00b5b;
  border-radius: 4px;
  color: #fff;
  font-size: 15px;
  font-weight: 500;

  svg {
    margin-right: 5px;
  }
  .btn--text {
    font-style: normal;
    font-weight: 500;
    color: #fff;
    width: 100%;
    text-align: center;
  }
}
.woven-strip {
  position: absolute;
  left: 0;
}
.woven-border-only {
  background: #fff;
  border: 1px solid #e00b5b;
  height: 40px;
  svg {
    margin-left: 5px;
  }
  .btn--text {
    font-style: normal;
    font-weight: 500;
    text-align: center;
    color: #e00b5b;
  }
}
.filter-dropdown {
  background: #fff;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 30px;
  z-index: 100;
  left: 0;
  min-width: 300px;
  .form__item {
    margin-bottom: 16px;
  }
}
.woven-red {
  color: #e00b5b;
}
.button-group {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  margin-top: 32px;
  border-top: 1px solid rgba(196, 196, 196, 0.5);
  p {
    width: 100%;
  }
  .btn {
    width: 100px;
    height: 40px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    padding: 10px;
    text-align: center;
  }
}
.date-group {
  display: flex;
}
.margin-right {
  margin-right: 16px;
}
.date {
  border: 0.5px solid rgba(97, 110, 124, 0.5);
  box-sizing: border-box;
  border-radius: 4px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(97, 110, 124, 0.8);
  padding: 12px 10px;
  width: 100%;
}
.status-element {
  display: flex;
  svg {
    margin-right: 10px;
    cursor: pointer;
  }
}
.text-light {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;
  span {
    color: #e00b5b;
    cursor: pointer;
  }
}
.filter-title {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 14px;
  color: #9a9fa3;
  // margin-bottom: 16px;
  margin: 5px 0;
}
// filter styles end
.empty__text {
  &__caption {
    max-width: 300px;
    line-height: 24px;
  }
}
.toggle-date {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;
  text-transform: capitalize !important;
  display: flex;
  .date {
    margin: 0 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */
    color: #e00b5b;
    cursor: pointer;
  }
}

.empty__text {
  &__caption {
    max-width: 300px;
    line-height: 24px;
  }
}
.toggle-date {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  color: #595959;
  text-transform: capitalize !important;
  display: flex;
  .date {
    margin: 0 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    color: #e00b5b;
    cursor: pointer;
  }
}
.btn-filter {
  height: 50px;
  border: 1px solid #fd8387;
  box-sizing: border-box;
  border-radius: 4px;
  background: transparent !important;
}
.no-bg {
  background: none !important;
}

.modal-body {
  justify-content: center !important;
  h2 {
    font-weight: 500;
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 14px;
  }

  p {
    margin-bottom: 31px;
    color: #616e7c;
  }

  svg {
    margin-bottom: 12px;
  }

  textarea {
    resize: none;
    height: 4rem;
  }

  .boxed {
    width: 60%;
    margin: 0.5rem auto 1.5rem;
    .form__flex__item,
    button {
      margin-left: 0;
      width: 100%;
    }

    .details__card__item {
      padding: 0 0 24px;
      border: none;
    }
  }
}
.retry-provider-shell {
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  background: rgba(38, 25, 64, 0.5);
}
.retry-provider-dialog {
  position: relative;
  width: 100%;
  max-width: 440px;
  max-height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
  overflow: visible;
}
.retry-provider-close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
  padding: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;
}
.retry-provider-close:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.retry-provider-dialog__body {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
  padding: 28px 24px 24px;
  text-align: left;
  overflow: visible;
}
.retry-provider-dialog__header {
  text-align: center;
  flex-shrink: 0;
}
.retry-provider-dialog__header h2 {
  font-weight: 500;
  font-size: 26px;
  line-height: 32px;
  margin: 0 0 10px;
  color: #261940;
}
.retry-provider-dialog__header p {
  margin: 0 0 20px;
  color: #616e7c;
  font-size: 15px;
}
.retry-provider-dialog__main {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
}
.retry-provider-field-label {
  font-size: 12px;
  line-height: 14px;
  color: #261940;
  opacity: 0.6;
  margin: 0 0 8px;
}
.retry-provider-dd {
  position: relative;
  z-index: 5;
  width: 100%;
}
.retry-provider-dd__trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12.92px;
  background: #ffffff;
  border: 1px solid #cbd2d9;
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
  text-align: left;
}
.retry-provider-dd__trigger-text {
  font-size: 14px;
  line-height: 14px;
  color: #261940;
}
.retry-provider-dd__chevron {
  flex-shrink: 0;
  transition: transform 0.15s ease;
}
.retry-provider-dd__chevron--open {
  transform: rotate(180deg);
}
.retry-provider-dd__panel {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 4px);
  z-index: 20;
  max-height: min(320px, 45vh);
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  background: #ffffff;
  border: 1px solid #cbd2d9;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(37, 40, 43, 0.18);
}
.retry-provider-dd__option {
  display: block;
  width: 100%;
  padding: 12px 14px;
  border: none;
  border-bottom: 1px solid rgba(38, 25, 64, 0.08);
  background: #ffffff;
  font-size: 14px;
  line-height: 1.35;
  color: #261940;
  text-align: left;
  cursor: pointer;
}
.retry-provider-dd__option:last-child {
  border-bottom: none;
}
.retry-provider-dd__option:hover {
  background: #f0f0f0;
}
.retry-provider-dd__option--active {
  background: #ffffff;
  box-shadow: inset 3px 0 0 #cbd2d9;
}
.retry-provider-dd__option--active:hover {
  background: #f0f0f0;
}
.retry-provider-dialog__main .retry-provider-submit {
  margin-top: 16px;
  width: 100%;
  flex-shrink: 0;
}
.retry-provider-empty {
  text-align: center;
  color: #616e7c;
}
.confirm_btn {
  font-family: Lato;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  background-color: white;
  border-radius: 6px;
  border: 1px solid #e00b5b;
  box-sizing: border-box;
  color: #e00b5b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  width: fit-content;
  padding-left: 16px;
  padding-right: 16px;
  text-wrap: nowrap;
}
.reverse_btn {
  font-family: Lato;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  background-color: #e00b5b;
  border-radius: 6px;
  border-style: none;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  width: fit-content;
  padding-left: 16px;
  padding-right: 16px;
  text-wrap: nowrap;
}
.tab__content__top__left {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.green-status {
  color: #00b87c;
}
.red-status {
  color: #e00b5b;
}
.other-status{
  color: #FFBF00;
}
.actions{
  display: flex;
  align-items: center;
  gap: 16px;
  width: fit-content;
}
.reverse-icon{
  height: 40px;
  width: 40px;
  color: #E00B5B;
  cursor: pointer;
}
.retry-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: pointer;
}
.retry-icon:hover {
  opacity: 0.85;
}
.retry-icon--disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;
}
.hide{
  display: none !important;
}
</style>
